import { Moon, Sun } from "lucide-react";
import { useThemeMode } from "./theme-mode";
import { t } from "@/lib/i18n";

/** Переключатель светлой/тёмной темы. compact — только иконка, для тесных шапок. */
export default function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { mode, toggle } = useThemeMode();
  const dark = mode === "dark";
  const label = dark ? t("Включить светлую тему") : t("Включить тёмную тему");

  return (
    <button
      type="button"
      onClick={toggle}
      title={label}
      aria-label={label}
      aria-pressed={dark}
      className="inline-flex items-center gap-2 whitespace-nowrap rounded-btn border border-border px-3 py-2 text-xs font-semibold text-muted-foreground transition hover:border-primary/60 hover:text-primary"
    >
      {dark ? <Moon className="size-4 flex-none" aria-hidden /> : <Sun className="size-4 flex-none" aria-hidden />}
      {compact ? null : <span className="hidden sm:inline">{dark ? t("Светлая тема") : t("Тёмная тема")}</span>}
    </button>
  );
}